export default __webpack_public_path__ + "static/media/document.04b1ee2a.svg";